import {Booking, BookingReason, CompanyLead, Partner} from ".";
import type {Voucher} from "./giftcard";
import {ProductType, ProductsCompany, productsCompany} from "./product";

export type DKK = number;

export interface Timeslot {
  start: string;
  end: string;
}

export type CompanyPaymentType = "CompanyFull" | "Employee" | "Shared" | "Bruttolønsordning";
export type CompanyLeadFrequency = "Ugentlig" | "Hver 2. uge" | "Månedligt" | "Andet";
export type ShortWeekDayString = "MON" | "TUE" | "WED" | "THU" | "FRI"; //"MAN" | "TIR" | "ONS" | "TOR" | "FRE";

export interface ICompanyLeadSettings {
  frequency?: CompanyLeadFrequency;
  wantedWeekDays?: ShortWeekDayString[];
  amountOfPeople?: string;
  wantedFromTime?: string;
  wantedToTime?: string;
  paymentSolution?: CompanyPaymentType;
  invoiceEmail?: string;
  comments?: string;
}

export {productsCompany};
export type {ProductType};

export const thirdPartyGiftCardProviders = ["SmartBox", "GoDream", "MoreBox", "SendEnTanke", "GoGift", "DenBedsteGave"] as const;
export const giftCardProviders = ["RaskRask", ...thirdPartyGiftCardProviders] as const;
export type ThirdPartyGiftCardProviders = typeof thirdPartyGiftCardProviders[number];
export type GiftCardProviders = typeof giftCardProviders[number];
export type Partners = Partner[];
export type BookingReasons = BookingReason[];
export type LeadOrBooking = CompanyLead | Booking;
export type {ProductsCompany};

export type VoucherOrNone = Voucher | {type: "NONE"};
